"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._Transition = {
    type: "structure",
    required: [],
    members: {
        Date: {
            shape: {
                type: "timestamp",
                timestampFormat: "iso8601"
            }
        },
        Days: {
            shape: {
                type: "integer"
            }
        },
        StorageClass: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_Transition.js.map